
export const REQUEST_SUB_LINKS = {
    orderRequest: {
        id: 1
        , link: 'Requests/MyRequest'
    }
    ,quotationRequest: {
        id: 2
        , link: 'Requests/QuotationRequest'
    }
    ,approvalRequest: {
        id: 3
        , link: 'Requests/ApprovalRequest'
    }
    ,coverageRequest: {
        id: 4
        , link: 'Requests/CoverageRequest'
    },
    allRequest: {
        id: 5
        , link: 'Requests/AllRequest'
    },
}

export const RAISE_REQUEST_ORDER_BASE = "RaiseRequest/Order/";

export const RAISE_REQUEST_LINKS = {
    orderRequest: {
        id: 1
        , link: 'MyRequest/' + RAISE_REQUEST_ORDER_BASE
    }
    , quotationRequest: {
        id: 2
        , link: 'QuotationRequest/' + RAISE_REQUEST_ORDER_BASE
    }
    , approvalRequest: {
        id: 3
        , link: 'ApprovalRequest/' + RAISE_REQUEST_ORDER_BASE
    }
    , coverageRequest: {
        id: 4
        , link: 'CoverageRequest/' + RAISE_REQUEST_ORDER_BASE
    },
    allRequest: {
        id: 5
        , link: 'AllRequest/' + RAISE_REQUEST_ORDER_BASE
    },
}

export const INVENTORY_REQUEST_LINK = {
    inventoryCircuitDetails: {
        id: 1
        , link: 'Details/'
    }
}

export const REQUEST_TYPE = {
    orderRequest: "MyRequest",
    quotationRequest: "QuotationRequest",
    approvalRequest: "ApprovalRequest",
    allRequest: "AllRequest",
    coverageRequest: "CoverageRequest",
    request: "Request",
    InternationalAccess:"International Access"
}

export const REQUEST_TAB_NAME = {
    allOrderRequest: "All Requests",
    myRequest: "My Requests",
    approvalRequest: "For Approval",
}

export const GET_REQUEST_HEADER_TITLE = [
    { Key: 4, Value: "Change User Request" },
    { Key: 14, Value: "Change Vendor Request" },
    { Key: 40, Value: "International Access Request" },
    { Key: 33, Value: "Replace/Upgrade Device Request" },
    { Key: 35, Value: "Accessory Request" },
    { Key: 7, Value: "Terminate Subscription Request" },
    { Key: 11, Value: "Port-Out Request" },
    { Key: 15, Value: "Other Request" },
    { Key: 9, Value: "New Mobile Subscription Request" },
    { Key: 12, Value: "Port-In Request" },
    { Key: 23, Value: "Other - Other Request" },
    { Key: 17, Value: "Other - SIM Activation Request" },
    { Key: 37, Value: "Other - Change Number Request" },
    { Key: 36, Value: "Other - Enable Hotspot Request" },
    { Key: 41, Value: "International Access - Calling Access Request" },
    { Key: 38, Value: "Other - Suspend/Resume Service Request" }
]


export const REQUEST_TYPES_ID = {
    //wireless requests
    newCircuitOrder: 1
    , manageExisting: 2
    , newOrder: 3
    , changeUser: 4
    , changePricePlan: 5
    , simReplacement: 6
    , subscriptionCancellation: 7
    , newMobile: 9
    , terminate: 10
    , portOut: 11
    , portIn: 12
    , deviceReplacement: 33
    , changeVendor: 14
    , otherRequestOther: 15
    , accessory: 35
    , intlRoamingAccess: 40
    //Wireline Request
    , upgradeSubscriptionWireline: 24
    , terminateSubscriptionWireline: 25
    , otherWireline: 26
    , newSubscriptionWireline: 27
    , newQuotation: 28
    , wirelineChangeVendor: 29

    //wireline other request
    , wirelineUpgradeCircuit: 30
    , wirelineChangeLocationAddress: 31
    , wirelineOtherOther: 32

    //other request types
    , newHomeOfficeConnection: 16
    , simActivation: 17
    , roamingActivation: 18
    , pukCode: 19
    , itemizedBillingofCallsReport: 20
    , changeInvoiceAddress: 21
    , moveHOC: 22
    , other: 23
    , changeNumber: 37
    , enableHotspot: 36
    , suspendResumeService: 38
    , CallingAccess:41
};

export const REQUEST_TYPES_LABEL = {
    //wireless requests
    PORTIN: 'Port-In'
    , OTHER: 'Other'
    
};

export const CIRCUIT_CATEGORIES = {
    mobile: 1,
    fixed: 2,
    hoc: 3,
};

export const WIRELINE_REQUEST_TYPES_ID = {

    //Wireline Request
    upgradeSubscriptionWireline: 24,
    terminateSubscriptionWireline: 25,
    otherWireline: 26,
    newSubscriptionWireline: 27,
    newQuotation: 28,
    wirelineChangeVendor: 29,
    //wireline other request
    wirelineUpgradeCircuit: 30,
    wirelineChangeLocationAddress: 31,
    wirelineOtherOther: 32,

};
export const WIRELESS_REQUEST_TYPES_ID = {
    mobileCellPhone: 1,
    dataCard: 2,
    mobileOfficeConnection: 3,
};

export const ORDER_AUDIT_TYPES = {
    orderCreated: 1,
    commentOrder: 2,
    updateOrder: 3,
    assignOrder: 4,
    approveOrder: 5,
    rejectOrder: 6,
    expiredOrder: 7,
    requestedInBehalf: 8,
    cancelOrder: 9,
    orderSubmitted: 10,
    orderReceiptConfirmed: 11,
    orderCompleted: 12,
};
export const INVALID_CHARS = [
    "-",
    "+",
    ".",
    "e"
];

export const OTHER_MENU_FILTER = [
    { Key: 21, Value: "Change Invoice Address" },
    { Key: 20, Value: "Itemized Billing of Calls Report" },
    { Key: 22, Value: "Move HOC" },
    { Key: 23, Value: "Other" },
    { Key: 19, Value: "PUK Code" },
    { Key: 18, Value: "Roaming Activation" },
    { Key: 17, Value: "SIM Activation" },
    { Key: 36, Value: "Enable Hotspot" },
    { Key: 37, Value: "Change Number" },
    { Key: 38, Value: "Suspend/Resume Service" },
    { Key: 36, Value: "Enable Hotspot" },   
];

export const INTERNATIONAL_REQUEST_FILTER = [
   
    { Key: 40, Value: "Roaming Access" },
    { Key: 41, Value: "Calling Access" },

];
export const ORDER_AUDIT_VERBIAGE = { 
    orderCreated: 'Request logged',
    commentOrder: '{name} {commented} on your request',
    deleteCommentOrder: 'Comment was deleted on {yearDayMonth} at {time}',
    updateOrder: '{name} updated on your request',
    assignOrder: 'Request assigned to {name} of the analyst',
    approveOrder: 'Request approved',
    rejectOrder: 'Request rejected',
    expiredOrder: 'Request expired',
    requestedInBehalf: '{name} raised the request',
    cancelOrder: 'Request cancelled',
    orderSubmitted: 'Order submitted',
    orderReceiptConfirmed: 'Order receipt confirmed',
    orderCompleted: 'Order completed',
    order: 'order'
};
export const REQUEST_LOG_FILTER_BY = {
    requestType: { filter: 'Request', title: 'Request' , subItems: [] },
    other: { filter: 'Other', title: 'Other' },
    owner: { filter: 'Owner', title: 'Owner' },
    status: { filter: 'Status', title: 'Status' },
};


export const REQUEST_LOG_FILTER_BYs = {
    samplecheck: "Roaming Access",
    samplecheck2: "Calling Access",
};


export const REQUEST_STATUS = {
    inProgress: "Waiting for Approval",
    open: "Open",
    inProgressAwaitingToVendor: "In Progress (Awaiting Submission to Vendor)",
    inProgressSubmittedToVendor: "In Progress (Submitted to vendor)"
}

export const REQUEST_STATUS_TXT = {
    forApproval: "For First Level Approval"
}

export const PrimarySecondaryString = {
    primary: "primary",
    secondary: "secondary",
    both: "both"
}
export const PrimarySecondaryInt = {
    primary: 1,
    secondary: 2,
    both: 3
}

export const CODE_DETAIL_ID =
{
    Other: 18,
    Business: 23,
    Personal: 24
}

export const FILE_ATTACHMENT_MODULES = {
    orderCreation: 1,
    orderComments: 2,
    circuitComments: 3,
    equipmentComments: 4,
    disputeComments: 5,
    invoiceComments: 6,
    invoiceFileAttachment: 7,    
}

export const EXTRACT_TEMPLATE_MODULES ={
    genericTemplate: 11,
    chargeMappingTemplate: 12,
}

export const USER_ROLES_ID = {
    admin: 1,
    analyst: 2,
    reporting: 3,
    client: 4,
    manager: 5,
    lineManager: 6,
    teamLead: 10
};

export const ORDER_STATUS = {
    waitingForAuthorization: 2,
    rejected: 3,
    approved: 6,
    completed: 1,
    canceled: 15,
    open: 12,
    progress: 9,
    progress_awaiting_submission: 4
};
export const ORDER_STATUS_TEXT = [
    { id: 2, value: "WAITING FOR APPROVAL"},
    { id: 3, value: "REJECTED", customClass:"cancelled-status-color" },
    { id: 6, value: "APPROVED", customClass:"approved-status-color"},
    { id: 1, value: "COMPLETED" },
    { id: 15, value: "CANCELLED", customClass:"cancelled-status-color"},
    { id: 12, value: "OPEN" },
    { id: 9, value: "IN PROGRESS (Submitted to vendor)" },
    { id: 4, value: "IN PROGRESS (Awaiting Submission to vendor)" },
];
export const INPUT_FIELD_TYPE = {
    type:'number'
}

export const POWER_BI_SUBREPORT = "report_5";

export const CSAT_SETTINGS = {
    lbl_title: "TEM Survey",
    questionCount: 4,
    lbl_required: "Required",
    lbl_surveyVerbiage:
        'With this survey, we will be able to evaluate the service that we provide to you! Please note that Very dissatisfied is the lowest score and Very satisfied is the highest score.',
    lbl_completionVerbiage: 'Thank you for completing our survey!',
    lbl_comments: "Comments"
};

export const PURPOSEOFUSEOPTIONS = {
    directLine: "Direct line",
    backupLine: "Backup line"
}

export const DATE_FORMATS = [
    {
      format: "DD/MM/YYYY"
    },
    {
      format: "MM/DD/YYYY"
    },
    {
      format: "YYYY/MM/DD"
    },
    {
        format: "MMM DD, YYYY"
    },
    {
        format: "MMMM DD, YYYY"
    },
    {
        format: "DD MMM, YYYY"
    },
    {
        format: "DD MMMM, YYYY"
    },
  ];

export const DATE_FORMATS_MESSAGE = {
    Message:"Changing the default date format will affect all of the date fields available in ATEM across all users.",
    SeconeMessage:'If you want to proceed on changing the default date format please select "Confirm", otherwise "Discard".'
}

export const DEFAULT_TABLE_RESULT_MODEL = {
    Data: {
        Items: []
    },
    Headers: {},
    Columns: {
        Default: [],
        Available: [],
        Selected: [],
    },
    Pagination: {
        PageNumber: 0,
        PerPage: 10,
        PageSizes: [
            10,
            20,
            30
        ],
        TotalEntries: 0,
        TotalPages: 0,
        HasNext: false,
        HasPrevious: false
    },
    TableFilterData: {
        FilterList: [],
        Operatorlist: [],
        OptionList: [],
    },
    SortedColumnName: "",
    IsSortAscending: true,
    StatusFilter: {
        FirstFilter: 0,
        SecondFilter: 0,
        ThirdFilter: 0,
        FourthFilter: 0,
        TotalFilter: 0,
    },
    ApplyStatusFilter: 0,
}

export const DEFAULT_TABLE_RESULT_EQUIPMENT_DROPDOWN_MODEL = {
    EquipmentTypes : [],
    Vendors: [],
    EquipmentStatuses : [],
    GlCodes: [],
    CostCenters : [],
    Contracts: [],
    CompanyCodes: [],
    IsVIPOption: [],
    CircuitTypes : [],
}

export const TYPE_FUNCTION="function";

export const ACTION_TYPES ={
    Add:"Add",
    Delete:"Delete",
    Update:"Update"
}

export const REPORT_COLUMN_MODULE = {
    CircuitInventoryReport: 1,
    SemiAnnualCostAllocAccrualReport: 2,
    AccrualReportDetails: 3,
    CircuitInventoryManagement: 4,
    ASPUInventoryManagement: 5,
    ASRInventoryManagement: 6,
    EquipmentInventoryManagement: 7,
    OrderRequestManagement: 8,
    DisputeInvoiceManagement: 9,
    InvoiceInvoiceManagement: 10
}

export const Selected_Index ={
    i_Zero: "0",
    i_One: "1",
    i_Two: "2",
    i_Three: "3",
    i_Four: "4",
    i_Five: "5",
    i_Six: "6",
    i_Seven: "7"
}

export const Allowed_Extension = [
    'CSV', 'XLS', 'XLSX', 'DOCX', 'PDF',
    'TXT', 'ZIP', 'MSG', 'PNG', 'JPG','JPEG',
    'BMP', 'csv', 'xls', 'xlsx', 'docx', 'pdf',
    'txt', 'zip', 'msg', 'png', 'jpg','jpeg','bmp'
]


export const Conf_Message_Allowed_Extension = [
    'CSV', 'XLS', 'XLSX', 'DOCX', 'PDF',
    'TXT', 'ZIP', 'MSG (email)', 'PNG', 'JPG','JPEG',
    'BMP'
]

export const PDF_Extension ='pdf';

export const BUSINESS_CASE = {
    other: 139
};

export const CIRCUIT_SIM_RANK = {
    Primary: "Primary",
    Secondary: "Secondary"
}

export const SELECT_OPERATOR = {
    Between: "Between",
    Equal: "Equal",
    Not_Equal: "Not Equal"
}

export const EQUIPMENT_TYPE = {
    Device: 1,
    Accessory: 2,
    DeviceName: 'Device',
    AccessoryName: 'Accessory'
}

export const CIRCUIT_STATUS = {
    inService: { id: 1, name: 'In Service' },
    outOfService: { id: 2, name: 'Out of Service' },
    suspended: { id: 3, name: 'Suspended' },
    pending: { id: 4, name: 'Pending' },
}

export const MAX_LENGTH = {
    inputText: 50,
    limit_100: 100,
    limit_500: 500,
    limit_1000: 1000,
    limit_255: 255,
}

export const DISPLAY_ITEM = {
    five: 5,
    six: 6,
    seven: 7,
    ten: 10
}

export const REF_CODE_TYPE = {
    URP: 1,
    QRT: 2,
    QCT: 3,
    QRC: 4,
    QRB: 5,
    URL: 6,
    EDP: 7,
    IDP: 8,
    CDRCTT: 9,
    AIGCT: 10,
    MPLS_A: 11,
    MPLS_AB: 12,
    MPLS_EOI: 13,
    MPLS_SP: 14,
    MPLS_CQP: 15,
    MPLS_VN: 16,
    MPLS_SO: 17,
    PTP_SC: 18,
    MPLS_VCS: 19,
    BUS_JUST: 20
}

export const OPTION_LABEL = {
    KEY_VALUE: { Key: 'Key', Value: 'Value' },
    KEY_VALUE_LABEL: { Key: 'Key', Value: 'Value', Label: 'Label' }
};

export const DISPLAY_OPTION = {
    KEY: 'Key',
    VALUE: 'Value',
    LABEL: 'Label'
};

export const PLACEHOLDER = {
    SELECT: "Select..."
    , ENTER_TEXT_HERE: "Enter text here..."
};

export const EQUIPMENT_MSG = {
    CREATED_MSG: "Equipment has been created"
    , UPDATED_MSG: "Equipment has been updated"
    , EXISTS_MSG: "Equipment already exist on the vendor"
    , CONFIRM_UPDATE_MSG: "Are you sure you want to save?"
    , CONFIRM_CREATE_MSG: "Do you want to create new equipment?"
};

export const ORDER_MSG = {
    SUBMITTED_MSG: "Order has been submitted"
};

export const APPROVAL_MESSAGE = {
    ACTION_CONFIRMATION: "Are you sure you want to",
    TARGET_REQUEST: "the order request?",
    APPROVE_REQUEST: "Approve Request",
    REJECT_REQUEST: "Reject Request",
    APPROVE: "approve",
    REJECT: "reject"
}

export const MODAL_TITLE = {
    ERROR: "Error"
    , SUCCESS:"Success"
    , ADD_NEW:"Add New"
    , UPDATE: "Update"
    , SUBMIT_FORM: "Submit Form Request"
};

export const DATA_TYPE = {
    decimal: "decimal",
    int: "int",
    float: "float",
    string: "string"
}

export const REF_SIM_TYPE = {
    standard: { id: 1, name: "Standard" },
    standard4g: { id: 2, name: "Standard - 4G" },
    standardLTE: { id: 3, name: "Standard - LTE" },
    micro: { id: 4, name: "Micro" },
    micro4g: { id: 5, name: "Micro - 4G" },
    microLTE: { id: 6, name: "Micro - LTE" },
    nano: { id: 7, name: "Nano" },
    nano4g: { id: 8, name: "Nano - 4G" },
    nanoLTE: { id: 9, name: "Nano - LTE" },
    scada: { id: 10, name: "SCADA" },
    triCutSIM: { id: 11, name: "Tri-Cut SIM" },
    eSIM: { id: 12, name: "eSIM" }
}

export const ERROR_TYPE = {
    existingServiceType: "ExistingServiceType",
    existingOpenRequestWithServiceType: "ExistingOpenRequestWithServiceType",
    invoiceNumberNotExist: "InvoiceNumberNotExist",
    billedCircuitIdNotExist: "BilledCircuitIdNotExist",
    matchedCircuitIdNotExist: "MatchedCircuitIdNotExist"
}

export const NOTIFICATION_NAME_KEY = {
    operationBusinessHours: "OperationBusinessHours"
}

export const SUBMIT_REQUEST = {
    updateRequest: "Do you want to update this request?",
    submitRequest: "Do you want to submit this request?"
}

export const SUBMIT_REQUEST_TITLE ={
    submitRequest: "Submit Form Request",
    updateRequest: "Update Form Request"
}

export const SERVICE_STATUS = {
    inService : "In Service",
    suspended: "Suspended"
}

export const PROPERTY_NAME = {
    Name : 'Name'
}

export const AUDITRULES_REPORT_HEADERS = {
    InvoiceNum: "Invoice Number",
    BilledCircuitId: " Billed Circuit ID",
    MatchedCircuitCode: "Matched Circuit ID",
    AuditRulesException: "Exception",
    CreatedBy: "Created By",
    DateModified: "Date Modified",
    AuditRulesResultsStatusName: "Status",
    DateCreated:"Date Created ",
    AdditionalInformation: "Additional Information",
    ModifiedBy: "Modified By",
    DisputeCode: "Dispute ID",
    DisputeStatus: "Dispute Status",
  
}

export const  AUDITRULES_REPORT_PROPS = {
    InvoiceNum: "InvoiceNum",
    BilledCircuitId: "BilledCircuitId", 
    DateModified: "DateModified",
    DisputeCode: "DisputeCode",
    MatchedCircuitCode: "MatchedCircuitCode",
    AuditRulesException: "AuditRulesException",
    AuditRulesResultsStatusName: "AuditRulesResultsStatusName",
    AdditionalInformation: "AdditionalInformation",
    ModifiedBy: "ModifiedBy",
    CreatedBy: "CreatedBy",   
    DisputeStatus: "DisputeStatus",
    DateCreated:"DateCreated",
  
  
}
export const INVENTORY_REPORT_HEADERS = {   
    region: "Region",   
    circuitNumber: "Circuit Number",
    vendorName: "Vendor Name",
    circuitCountry: "Circuit Country",
    account: "Account",
    circuitRanking: "Circuit Ranking",
    circuitStatus: "Circuit Status",
    circuitType: "Circuit Type",
    subCircuitStatus: "Sub-Circuit Type",
    pukCode: "PUK Code",
    inServiceDate: "In Service Date",
    cancelledDate: "Cancelled Date",
    dateLeft: "Date Left",
    lastName: "Last Name",
    firstName: "First Name",
    userName: "UserName",
    userHRID: "User HRID",
    userEmailAdd: "User Email Address",
    userVIP: "User VIP",
    costCode: "Cost Code",
    location: "Location",
    userSiteLocation: "User Site Location",
    userCountry: "User Country",
    userCity: "User City",
    prefixCountry: "Prefix Country",
    userJobTitle: "User Job Title",
    hrTeamName: "HR Team Name",
    imei: "IMEI/Serial Number",
    deviceType: "Device Type",
    planName: "Plan Name",
    planComponent: "Plan Component",
    description: "Description",
    baseCost: "Base Cost",
    planComponentCost: "Plan Component Cost",
    totalCost: "Total Cost",
    userLineManager: "User Line Manager",
    lineManagersEmail: "Line Managers Email",
    lmVIP: "LM VIP",
    lineManagerHRID: "Line Manager HRID",
    orderNumber: "Order Number",
    requestType: "Request Type",
    currency: "Currency",
    userStatus: "User Status",
    businessCase: "Business Case",
    simSerialNumber: "SIM Serial Number",
    subscriptionNumber: "Circuit ID",
    userFullName: "Username",
    hrid: "HRID",
    equipmentModel: "Device Type",
    vendor: "Vendor",
    mrc: "Price Component",
}

export const INVENTORY_REPORT_PROPS = {
    region: "Region",
    circuitID: "CircuitId",
    vendor: "Vendor",
    circuitCountry: "CircuitCountry",
    accountNumber: "AccountNumber",
    circuitRanking: "CircuitRanking",
    circuitStatus: "CircuitStatus",
    circuitType: "CircuitType",
    subCircuitType: "SubCircuitType",
    puk: "PUK",
    installDateStr: "InstallDateStr",
    disconnectDateStr: "DisconnectDateStr",
    dateLeftStr: "DateLeftStr",
    lastName: "UserLastName",
    firstName: "UserFirstName",
    userFullName: "UserFullName",
    userHRID: "UserHrId",
    userEmailAdd: "UserEmailAdd",
    userVIP: "UserVIP",
    costCode: "CostCode",
    location: "Location",
    userLocationSite: "UserLocationSite",
    userLocationCountry: "UserLocationCountry",
    userLocationCity: "UserLocationCity",
    prefixCountry: "PrefixCountry",
    userJobTitle: "UserJobTitle",
    hrTeamName: "HrTeamName",
    imei: "IMEI",
    equipmentModel: "EquipmentModel",
    planName: "PlanName",
    planComponent: "PlanComponent",
    description: "Description",
    baseCost: "BaseCost",
    planComponentCost: "PlanComponentCost",
    totalCost: "TotalCost",
    userLineManager: "UserLineManager",
    lineManagerEmail: "LineManagerEmail",
    lmVIP: "LMVip",
    lineManagerHRID: "LineManagerHRID",
    orderNumber: "OrderNumber",
    requestType: "RequestType",
    currency: "Currency",
    userStatus: "UserStatus",
    businessCase: "BusinessCase",
    simSerialNumber: "SIMSerialNumber",
    subscriptionNumber: "SubscriptionNumber",
    mrc: "MRC",
}

export const TABLE_PAGINATION_KEY = {
    inventoryCircuit: "inventory-circuit",
    inventoryASPU: "inventory-aspu",
    inventoryASR: "inventory-asr",
    inventoryEquipment: "inventory-equipment",
    invoiceInvoice: "invoice-invoice",
    invoiceDispute: "invoice-dispute",
    requestAllRequest: "request-all-request",
    requestMyRequest: "request-my-request",
    requestApprovalRequest: "request-approval-request"
}

export const EXTERNAL_LINK_TYPES = {
    userGuide: 1,
    mobilePolicy: 2,
    powerBIReports: 3
}
export const DEFAULT_PAGE_SIZES = [10, 20, 30]

export const DISPUTE_TYPES_TEXT_ID = {
    billingAccountMismatch: "BillingAccountMismatch",
    ceasedButCharging: "CeasedButCharging",
    circuitNotFound: "CircuitNotFound",
    costAllocationNotFound: "CostAllocationNotFound",
    differentProvider: "DifferentProvider",
    discountNotApplied: "DiscountNotApplied",
    invoicePercent: "InvoicePercent",
    mrcMismatch: "MRCMismatch",
    unbilledCircuit: "UnbilledCircuit",
    firstBill: "FirstBill",
}

export const MILESTONE = [
    "first",
    "second",
    "third",
    "fourth"
]

export const FOLLOWUP_DETAILS=[
    { title: "first_follow_up", textLabel: "first_follow_up_details", dateLabel: "first_follow_up_date", type: "FirstFollowUp" },
    { title: "second_follow_up", textLabel: "second_follow_up_details", dateLabel: "second_follow_up_date", type: "SecondFollowUp" },
    { title: "third_follow_up", textLabel: "third_follow_up_details", dateLabel: "third_follow_up_date", type: "ThirdFollowUp" },
    { title: "fourth_follow_up", textLabel: "fourth_follow_up_details", dateLabel: "fourth_follow_up_date", type: "FourthFollowUp" },
]

export const DISPUTE_HISTORY_OBJ = {
    mrc: "MRC",
    annualPotentialSavings: "Annual Potential Savings",
    annualRealizedSavings: "Annual Realized Savings",
    potentialsavings: "Potential Savings",
    realizedSavings: "Realized Savings"
}

export const DASHBOARD_LABEL = {
    total: "Total",
    open: "Open",
    inProgress: "In-Progress",
    closed: "Closed",
    rejected: "Rejected",
    pending: "Pending",
    approved: "Approved",
    paid: "Paid"
}

export const DEFAULT_PAGE_VALUE = {
    "PageNumber": 0,
    "PerPage": 10,
    "TotalPages": 1,
    "TotalEntries": 1,
    "HasNext": true,
    "HasPrevious": false,
    "PageSizes": [
        10,
        20,
        30
    ]
}

export const UPLOAD_NOTIFICATION_MESSAGE={
    RemoveFile:"Are you sure you want to remove the attached file?"
}

export const INVOICE_STATUS = {
    NotExpectedInvoice: 1,
    NotReceived: 2,
    Requested: 3,
    ProcessedSentToAP: 4,
    Processed: 5,
    Rejected: 6,
    Escalated: 7,
    Submitted: 8,
    ForAudit: 9,
    Paid: 10
}

export const MODAL_CUSTOM_TITLE={
    Confirmation:"Confirmation",
    Notification:"Notification",
    Error:"Error"
}

export const MODAL_CUSTOM_MESSAGE={
    delete: "Are you sure you want to delete?",
    match_audit_confirmation: "Are you sure you want to perform the selected audit rules?",
    match_audit_notification: "Match/Audit will now run on background. Please check the notification for status",
    exception_confirmation: "Are you sure you want save?",
    upload_notification: "The upload progress will now run on background. Please check the notification for the upload status",
    maximum_files: "Exceeded number of maximum files",
    invalid_file_type: "Invalid file type"
}

export const INVOICE_NOTIFICATION_STATUS={
    completed: {
        key: "Completed", value: "Completed"
    },
    failed: {
        key: "Failed", value: "Failed"
    },
    inProgress: {
        key: "InProgress", value: "In Progress"
    },
    pending : {
        key: "Pending", value: "Pending"
    }
}

export const ROUTE_LINK_LOCATION = {
    invoiceRouteLink: "/external/invoice/linked-invoice",
    circuitRouteLink: "/external/inventory/linked-circuit",
    inventoryCircuitLink: "/external/Inventory/matched-circuit/",
    invoiceDisputeLink: "/external/Invoices/Disputes",
    invoiceDisputeDetailsLink:"/external/Invoices/Disputes/DisputeDetails",
    invoiceDisputeCreateNewLink:"/external/Invoices/Disputes/New",
    invoiceDashboard: "/external/Invoices/Invoices",
    invoiceUpload: "/external/Invoices/InvoiceUpload"
}

export const AUDIT_MODAL_TITLE={
    AuditRules:"Audit Rules",
    CircuitNotFound: "Circuit Not Found"
}

export const AUDIT_GRAPH_TITLE= [
   "Valid Exception",
   "Invalid Exception"
]

export const AUDIT_KEY={
    "DisputeId":"DisputeId",
    "CircuitId":"CircuitId",
    "Exception": "Exception",
    "MatchedCircuitCode": "MatchedCircuitCode",
    "DisputeCode": "DisputeCode",
}

export const AUDIT_LEDGER ={
     valid:[
        {color:'#004c6d'}, 
        {color:'#205e7e'}, 
        {color:'#357090'},
        {color:'#4983a2'},
        {color:'#5d97b4'},
        {color:'#71abc6'},
        {color:'#85bfd9'},
        {color:'#99d4ec'},
        {color:'#aee9ff'},    
    ],  
    invalid:[
        {color:'#e98c01'}, 
        {color:'#ea9c29'}, 
        {color:'#ebab43'},
        {color:'#edb95b'},
        {color:'#efc774'},
        {color:'#f2d48d'},
        {color:'#f5e1a6'},
        {color:'#f9edbf'},
        {color:'#fff9d9'},   
    ]
}

export const LABEL_FORMAT= {
    "ExceptionDetails": 'exception_details',
    "DateCreated": 'date_created',
    "DateModified": 'date_modified',
    "CreatedBy": 'created_by',
    "ModifiedBy": 'modified_by',
    "InvoiceNumber": 'invoice_number',
    "AccountNumber": 'account_number',
    "BilledCircuitId": 'billed_circuit_id',
    "BilledAmount": 'billed_amount',
    "DisputeId": 'dispute_id',
    "DisputeStatus": 'dispute_status',
    "PotentialSavings": 'potential_savings',
    "RealizedSavings": 'realized_savings',
    "MatchedCircuitId": 'matched_circuit_id',
    "MRC": 'mrc',
    "MatchedCircuitIdAccountNumber": 'matched_circuit_id_account_number',
    "AllocationLevel": 'allocation_level',
    "CircuitStatus": 'circuit_status',
    "DisconnectDate": 'disconnect_date',
    "CurrentTotalAmountDue": 'current_total_amount_due',
    "PreviousTotalAmountDue": 'previous_total_amount_due',
    "Difference": 'difference',
    "PercentageChange": 'percentage_change',
    "InstallDate": 'install_date',
    "InvoiceDetails": "invoice_details",
    "DisputeDetails": "dispute_details",
    "RecurringCharges": "recurring_charges",
    "User": 'user',
    "Status": 'status',
}

export const AUDIT_RULES = [
    { value: "Select All", 
      key:"SelectAll",     
      tooltip: "Selects all rules" },
    { value: "Circuit Not Found", 
      key: "CircuitNotFound",
      id: 1,
      disabled:true,
      tooltip: "Check if there is a matching Circuit ID on the Circuit Inventory for the Invoice Billed Circuit ID/Line Item" 
    },
    { value: "Billing Account Mismatch",
      key:"BillingAccountMismatch", 
      id: 2,
      tooltip: "Check if the Billing Account Number of the invoice matches the Billing Account Number of the Circuit ID on the Circuit Inventory" 
    },
    { value: "Ceased But Charging", 
      key:"CeasedButCharging",
      id: 3,
      tooltip: "Check if the status of the Matched Circuit ID on the Circuit Inventory is \"Out of Service\"" },
    { value: "Cost Allocation Not Found", 
      key:"CostAllocationNotFound",
      id: 4,
      disabled:true,
      tooltip: "Check if the cost allocation details for the invoice is complete based on the Billing Account Number Allocation Level" 
    },
    { value: "First Bill", 
      key: "FirstBill",
      id: 5,
      tooltip: "Check if the circuit/mobile number is billed for the first time" 
    },
    { value: "Invoice Percent", 
      key: "InvoicePercent",
      id: 6,
      tooltip: "Check if the Total Amount Due of the invoice is within 20% tolerance rate from the Total Amount Due of the previous invoice" },
    { value: "MRC Mismatch", 
      key: "MRCMismatch",
      id: 7,
      tooltip: "Check if the MRC (Monthly Recurring Charges = Recurring Charges + Recurring Credits on the Subline Item)  of the Billed Circuit ID/Line Item matches the MRC of the Circuit ID on the Circuit Inventory" },
    { value: "Unbilled Circuit", 
      key: "UnbilledCircuit",
      id: 8,
      tooltip: " Check if there is an \"In Service\" Circuit ID on the Circuit Inventory under the Billing Account Number of the invoice that are not billed on the invoice" }
];


export const CIRCUIT_NOT_FOUND = {
    circuitNotFound: "Circuit Not Found"
}

export const GDPR_CONFIRMATION_MESSAGE = {
    exportAlertMsg: "Please confirm that the harvesting of data and it's usage has been approved by the client."
}

export const AUDIT_NOTE = {
    auditNote: "Note: This invoice is not yet matched to inventory. You may access Match/Audit function in AUDIT tab"
}

export const DEFAULT_SUBLINE_ITEM_CHARGE_TYPE = {
    barChart: [
        { name: "Domestic Fixed Calls", RoamingVoice: 800 },
        { name: "Roaming Data", RoamingData: 798 },
        { name: "Domestic Mobile Calls", DomesticMobileCalls: 632 },
        { name: "Internation Fixed Calls", InternationFixedCalls: 700 },
        { name: "Premium Calls", PremiumCalls: 543 },
        { name: "Roaming Voice", RoamingVoice: 768 }
    ],
}


export const TABLE_NO_LINK_DATA =[
    "Circuit Not Found"
]

export const TABLE_WARNING_ICON={
    AUDIT_TABLE:{
        columnName:"AuditRulesResultsStatusName",
        warningCondition :"AuditRulesResultsStatusInvalidFlag",
        tooltip: "This exception can now be tagged as Invalid"
    }
}

export const AUDIT_EXCEPTION = {
    billingAccountMismatch: "Billing Account Mismatch",
    ceasedButCharging: "Ceased But Charging",
    circuitNotFound: "Circuit Not Found",
    costAllocationNotFound: "Cost Allocation Not Found",
    invoicePercent: "Invoice Percent",
    mrcMismatch: "MRC Mismatch",
    unbilledCircuit: "Unbilled Circuit",
    firstBill: "First Bill",
}

export const DEFAULT_EXCEPTION_DETAILS = {
    AuditRulesDetails: {
        Exception: [],
        Invoice: [],
        Dispute: [],
    },
}

export const UPLOAD_TYPES = {
    HrUpload: 1,
    InventoryDeltaUpload: 2,
    PricePlanUpload: 3,
    CurrencyUpload: 4,
    InvoiceUpload: 5,
    ChargeTypeUpload: 6,
    GLCodeUpload: 10,
    CostCenterUpload: 11,
    FinanceAccountUpload: 12,
    FinanceCostAllocationUpload: 13,
    InventoryCostAllocationUpload: 14,
    APUpload: 15,
    EquipmentUpload: 16,
    InvoiceMatchAudit: 17
};

export const EXCEPTION_STATUS = {
    valid: { id: 1, name: 'Valid' },
    invalid: { id: 2, name: 'Invalid' },
}

export const INVOICE_HANDLER = {
    verizonwireless: 1,
    attmobility2: 37,
    tmobile: 40,
    generichandler: 103,
    attmobilityall: 107,
    verizonwireless2: 108
}

export const FILE_NAME_TEMPLATE = {
    genericTempalte: "ATEM Generic Template.xlsx",
    chargeMappingTemplate: "ROSS - Charge Mapping Template.xlsx",
}

export const CHARGE_MAPPING_UPLOAD_TYPES = {
    New: 1,
    Add: 2
};

export const CHARGE_MAPPING_FILE_LIMITATION = {
    maxFiles: 1,
    minFiles: 1,
    acceptedFiles: ".xlsx",
};